import { ApiProperty } from '../../codegen';
import { IsNumber, IsObject, IsString, Min, Max } from '../../validators';

export class BotMoveRequestDto {
  @ApiProperty()
  @IsString()
  gameSlug: string;

  @ApiProperty()
  @IsObject()
  state: Record<string, unknown>;

  @ApiProperty()
  @IsNumber()
  @Min(0)
  @Max(1)
  playerSlot: number;

  @ApiProperty()
  @IsNumber()
  @Min(0)
  @Max(1)
  difficulty01: number;
}

export class BotMoveResponseDto {
  @ApiProperty()
  @IsObject()
  action: Record<string, unknown>;
}
